import { render, staticRenderFns } from "./Ninja.vue?vue&type=template&id=4fbf9f36&scoped=true"
import script from "./Ninja.vue?vue&type=script&lang=js"
export * from "./Ninja.vue?vue&type=script&lang=js"
import style0 from "./Ninja.vue?vue&type=style&index=0&id=4fbf9f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf9f36",
  null
  
)

export default component.exports